import { toPcm16k } from '../lib/pcm.ts';

/**
 * „Podsłuch” mikrofonu: równolegle do rozpoznawania zapisuje dźwięk z tego samego strumienia, żeby w razie zawieszenia połączenia z Azure
 * dało się powtórzyć rozpoznawanie na nagraniu (bez proszenia dziecka o ponowne mówienie).
 * Tylko przeglądarka (Web Audio). Gdy się nie uda uruchomić — zwraca null, a aplikacja działa jak bez powtórek.
 */
export interface PcmTap {
  /** Dotychczas nagrane: 16 kHz, 16 bit, mono. */
  snapshot(): Int16Array;
  stop(): void;
}

interface AudioCtxLike {
  sampleRate: number;
  state?: string;
  destination: unknown;
  createMediaStreamSource(s: MediaStream): { connect(n: unknown): void; disconnect(): void };
  createScriptProcessor(bufferSize: number, inCh: number, outCh: number): { connect(n: unknown): void; disconnect(): void; onaudioprocess: ((e: { inputBuffer: { getChannelData(c: number): Float32Array } }) => void) | null };
  resume?(): Promise<void>;
  close(): Promise<void>;
}

export function startPcmTap(stream: MediaStream): PcmTap | null {
  const g = globalThis as { AudioContext?: new () => AudioCtxLike; webkitAudioContext?: new () => AudioCtxLike };
  const Ctor = g.AudioContext ?? g.webkitAudioContext;
  if (!Ctor) return null;
  try {
    const ctx = new Ctor();
    void ctx.resume?.();
    const source = ctx.createMediaStreamSource(stream);
    const proc = ctx.createScriptProcessor(4096, 1, 1);
    const chunks: Float32Array[] = [];
    proc.onaudioprocess = (e) => {
      chunks.push(new Float32Array(e.inputBuffer.getChannelData(0))); // kopia — bufor jest używany ponownie
    };
    source.connect(proc);
    proc.connect(ctx.destination); // bez tego część przeglądarek nie wywołuje onaudioprocess; wyjście jest ciszą (niczego do niego nie piszemy)
    return {
      snapshot: () => toPcm16k(chunks, ctx.sampleRate),
      stop: () => {
        try {
          proc.onaudioprocess = null;
          source.disconnect();
          proc.disconnect();
          void ctx.close();
        } catch {
          /* już zamknięte */
        }
      },
    };
  } catch {
    return null;
  }
}
